import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "load"
}
const _hoisted_2 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($setup.props.loading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("img", {
          class: "load-img",
          src: $setup.ballLoad,
          alt: ""
        }, null, 8 /* PROPS */, _hoisted_2),
        _createElementVNode("div", null, _toDisplayString(_ctx.$t('me.loding')), 1 /* TEXT */)
      ]))
    : _createCommentVNode("v-if", true)
}